module.exports = __webpack_public_path__ + "static/media/frame2.5c1407cd.png";